module.exports = __webpack_public_path__ + "img/freizeitPiccolo.f589dfec.jpg";